import React from 'react';
import styles from './Experience.module.css'
import image from '../../images/3.jpg'
import Aos from 'aos';
import 'aos/dist/aos.css';



export default function Experience () {

  React.useEffect(() => {
    Aos.init({duration: 2000})
  }, [])

  return (
    <div className={styles.container} id='experience'>
      <div className={styles.details} data-aos='fade-right'> 

        <h2> 5+ Years Ago? </h2>

        <p> Well, for the past 5+ years, I've been developing products for corporations and businesses all over the world, ranging from marketing websites to complicated solutions and enterprise apps, all with an emphasis on providing fast, elegant, and accessible user experiences. </p>
        <p> Currently, I work at YouMeCode Tech as a Senior Full Stack Engineer and Accessibility advocate crafting thoughtful and inclusive experiences that adhere to web standards for over a million merchants across the world. </p>
        <p> Before now, I was Core Web Engineer at DS Studios, where I taught and passed the knowledge of frontend web development to hundreds of people through different ethnics, races and religions. </p>
        <p> I once also led the Frontend team at a Spanish Company, Connecting through building multiple React applications into a single robust trading platform. </p>
        </div>

      <div className={styles.image} data-aos='fade-right'>
        <img src={image} />
      </div>

    </div>
  )
}